export default __webpack_public_path__ + "static/media/temp-icon.63051ce2.png";